import { render, staticRenderFns } from "./semanticLibrary.vue?vue&type=template&id=29c68c10&scoped=true&"
import script from "./semanticLibrary.vue?vue&type=script&lang=js&"
export * from "./semanticLibrary.vue?vue&type=script&lang=js&"
import style0 from "./semanticLibrary.vue?vue&type=style&index=0&id=29c68c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c68c10",
  null
  
)

export default component.exports